// URL <-> Home tab mapping. tabKey is the antd TabPane key; menuKey/evMenuKey
// select the sub-screen inside the Operator Trips / EV Trips dropdown tabs.
export const HOME_ROUTES = [
  { path: "/", tabKey: "1" },
  { path: "/connecting-trips", tabKey: "3" },
  { path: "/cab", tabKey: "19", menuKey: "1" },
  { path: "/last-mile", tabKey: "19", menuKey: "2" },
  { path: "/first-mile", tabKey: "19", menuKey: "3" },
  { path: "/contract-management", tabKey: "19", menuKey: "4" },
  { path: "/billing-management", tabKey: "19", menuKey: "5" },
  { path: "/tasks", tabKey: "2" },
  { path: "/gds", tabKey: "9" },
  { path: "/gds-lounge", tabKey: "12" },
  { path: "/geofence", tabKey: "4" },
  { path: "/outbound-calls", tabKey: "5" },
  { path: "/gds-outbound-calls", tabKey: "10" },
  { path: "/crew-tickets", tabKey: "8" },
  { path: "/ops-tickets", tabKey: "25" },
  { path: "/camera-feeds", tabKey: "7" },
  { path: "/live-view", tabKey: "6" },
  { path: "/audit-review", tabKey: "20" },
  { path: "/profile-review", tabKey: "21" },
  { path: "/route-mapping", tabKey: "22" },
  { path: "/ev-trips", tabKey: "23", evMenuKey: "1" },
  { path: "/ev-alerts", tabKey: "23", evMenuKey: "2" }
];

export const HOME_PATHS = HOME_ROUTES.map(route => route.path);

const stripTrailingSlash = pathname =>
  pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;

export const getHomeRoute = pathname =>
  HOME_ROUTES.find(route => route.path === stripTrailingSlash(pathname)) ||
  HOME_ROUTES[0];

// Path for a tab; dropdown tabs open whichever sub-screen was last selected.
export const getHomePath = (tabKey, { menuKey, evMenuKey } = {}) => {
  const route = HOME_ROUTES.find(
    r =>
      r.tabKey === String(tabKey) &&
      (!r.menuKey || r.menuKey === String(menuKey)) &&
      (!r.evMenuKey || r.evMenuKey === String(evMenuKey))
  );
  return route
    ? route.path
    : HOME_ROUTES.find(r => r.tabKey === String(tabKey)).path;
};
